import {switchMap} from "rxjs/operators";
import {ofType} from "redux-observable";

import * as actionTypes from "../constants/actionTypes";
import * as componentTypes from "../constants/componentTypes";
import * as methods from "../constants/methods";
import * as handlers from "../constants/handlers";
import * as config from "../constants/config";
import * as customersActions from "../actions/customersActions";
import * as reducerHelper from "../helpers/reducerHelper";

const customersTabInit = (action$) =>
    action$.pipe(
        ofType(actionTypes.CUSTOMERS_TAB_INIT),
        switchMap(({payload}) => {
            return [
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_CUSTOMERS_BY_PARAMS,
                        params: {
                            search: "",
                            rowCount: config.MAX_CUSTOMER_LIMIT,
                            offset: 0
                        }
                    },
                    method: handlers.GET_CUSTOMERS_BY_PARAMS,
                    tabId: payload.tabId
                }
            ];
        })
    );

const openCustomerInNewTab = (action$, state$) =>
    action$.pipe(
        ofType(actionTypes.OPEN_CUSTOMER_IN_NEW_TAB),
        switchMap(({payload}) => {
            let customersTab = reducerHelper.getTabByType(
                state$.value.navigation.tabList,
                componentTypes.CUSTOMERS_TAB
            );

            if (customersTab !== null) {
                return [
                    customersActions.selectCustomerOnCustomersTab(customersTab.id, payload.customerId),
                    {
                        type: actionTypes.SET_ACTIVE_TAB,
                        payload: {
                            tabId: customersTab.id
                        }
                    },
                    {
                        type: actionTypes.CUSTOMERS_TAB_RESET,
                        payload: {
                            tabId: customersTab.id
                        }
                    },
                    {
                        type: actionTypes.SERVER_REQUEST,
                        payload: {
                            type: methods.METHOD_GET_CUSTOMERS_BY_PARAMS,
                            params: {
                                search: "",
                                rowCount: config.MAX_CUSTOMER_LIMIT,
                                offset: 0
                            }
                        },
                        method: handlers.GET_CUSTOMERS_BY_PARAMS,
                        tabId: customersTab.id
                    }
                ];
            }

            let newTabId = reducerHelper.getNewTabId(state$.value.navigation.tabList);

            return [
                {
                    type: actionTypes.CUSTOMERS_TAB_INIT,
                    payload: {
                        tabId: newTabId
                    }
                },
                {
                    type: actionTypes.PREPARE_NEW_TAB,
                    payload: {
                        tabId: newTabId,
                        type: componentTypes.CUSTOMERS_TAB,
                        scene: componentTypes.DETAIL_SCENE
                    }
                },
                customersActions.selectCustomerOnCustomersTab(newTabId, payload.customerId)
            ];
        })
    );

export default [customersTabInit, openCustomerInNewTab];
